
import React from 'react';
import { Search, Filter } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface ArticleFiltersProps {
  searchTerm: string;
  selectedCategory: string;
  activeTab: string;
  categories: string[];
  onSearchChange: (value: string) => void;
  onCategoryChange: (value: string) => void;
  onTabChange: (value: string) => void;
}

const ArticleFilters: React.FC<ArticleFiltersProps> = ({
  searchTerm,
  selectedCategory,
  activeTab,
  categories,
  onSearchChange,
  onCategoryChange,
  onTabChange,
}) => {
  return (
    <>
      <div className="mt-8 flex flex-col md:flex-row gap-4">
        <div className="relative flex-grow">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
          <Input 
            placeholder="Search articles..." 
            className="pl-10"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
        <div className="w-full md:w-72">
          <Select value={selectedCategory} onValueChange={onCategoryChange}>
            <SelectTrigger>
              <Filter className="h-4 w-4 mr-2" />
              <SelectValue placeholder="Category" />
            </SelectTrigger>
            <SelectContent>
              {categories.map(category => (
                <SelectItem key={category} value={category}>
                  {category}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
      
      <Tabs defaultValue="all" className="mt-8" onValueChange={onTabChange}>
        <TabsList className="grid w-full md:w-96 grid-cols-3">
          <TabsTrigger value="all">All Articles</TabsTrigger>
          <TabsTrigger value="premium">Premium</TabsTrigger>
          <TabsTrigger value="free">Free</TabsTrigger>
        </TabsList>
      </Tabs>
    </>
  );
};

export default ArticleFilters;
